var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[_vm._v("Publicaciones por usuarios últimos 45 días:")]),_vm._v(" "),_c('b-list-group',_vm._l((_vm.newsFeedMetrics.created_by_count),function(metric){return _c('b-list-group-item',{key:metric.created_by},[_vm._v("\n      "+_vm._s(metric.concat)+" "),_c('span',{staticClass:"float-right"},[_vm._v(_vm._s(metric.occurrences))])])}),1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7395eed0","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/expertoRetail/views/trade/components/NewsFeedMetrics.vue
// module id = 929
// module chunks = 72